import classnames from 'classnames';
import type { CSSProperties, HTMLAttributes } from 'react';
import { useState } from 'react';

import styles from './useModalFade.module.scss';

type UseModalFadeOptions = {
  onClose: VoidFunction;
  animationTime?: number;
};

type UseModalFadeResult = [
  VoidFunction,
  Partial<HTMLAttributes<HTMLDivElement>>,
];

export function useModalFade(options: UseModalFadeOptions): UseModalFadeResult {
  const animationTime = options.animationTime ?? 200;
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);

    setTimeout(() => {
      options.onClose();
    }, animationTime);
  };

  const vars = { '--animation-time': `${animationTime}ms` } as CSSProperties;

  return [
    handleClose,
    {
      style: vars,
      className: classnames({
        [styles.fadeIn]: !isClosing,
        [styles.fadeOut]: isClosing,
      }),
    },
  ];
}
